import React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import SettingsSection from "./SettingsSection";

const Preferences = ({ formData, setFormData }) => {
  const { theme, setTheme } = useTheme();

  return (
    <SettingsSection title="Preferences" icon={<Moon />}>
      {/* Theme Selector */}
      <div className="flex flex-col space-y-3 py-2">
        <span className="text-sm text-gray-700 dark:text-gray-300">
          Theme
        </span>
        <div className="flex bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
          {[
            { id: "light", label: "Light", icon: Sun },
            { id: "dark", label: "Dark", icon: Moon },
            { id: "system", label: "System", icon: Monitor },
          ].map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setTheme(id)}
              className={`flex-1 flex items-center justify-center space-x-2 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                theme === id
                  ? "bg-white dark:bg-gray-500 text-gray-900 dark:text-white shadow-sm"
                  : "text-gray-500 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100"
              }`}
            >
              <Icon size={16} />
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Public profile toggle */}
      <div className="flex items-center justify-between py-2 border-t border-dashed mt-4 pt-4">
        <div>
          <div className="text-sm text-gray-700 dark:text-gray-300">
            Show my profile publicly
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">
            If turned off, other users won't be able to view your public profile
            card from leaderboards.
          </div>
        </div>

        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={formData.show_profile_public ?? true}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                show_profile_public: e.target.checked,
              }))
            }
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:ring-2 peer-focus:ring-green-500 rounded-full peer dark:bg-gray-600 peer-checked:bg-green-600 transition-colors" />
          <span className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-5" />
        </label>
      </div>
    </SettingsSection>
  );
};

export default Preferences;
